import ErrorAlert from "@/utility/ErrorAlert";
import InterfacePemeriksaanFisikRalan from "@/apiInterface/InterfacePemeriksaanFisikRalan";
import InterfaceNyeri from "@/apiInterface/InterfaceNyeri";

class DataNyeri {
  async getDataNyeri(rm) {
    let dt: any
    await InterfaceNyeri.getNyeri(rm).then((response) => {
      dt = response.data
    })
      .catch((e) => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Nyeri")
      });
    return dt
  }
  async getDataNyeriByReg(unit, reg) {
    let dt: any
    await InterfaceNyeri.getNyeriByReg(unit, reg).then((response) => {
      dt = response.data
    })
      .catch((e) => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Nyeri")
      });
    return dt
  }


  async saveDataNyeri(
    reg,
    unit_id,
    rm,
    param
  ) {
    let dt: object = {}
    await InterfaceNyeri.saveNyeri(
      reg,
      unit_id,
      rm,
      param
    ).then((response) => {
      dt = response.data
    })
      .catch((e) => {
        dt = e.response
        ErrorAlert.showErrorAlert(e)
      });
    return dt
  }

  async editDataNyeri(
    id,
    reg,
    unit_id,
    rm,
    param
  ) {
    let dt: object = {}
    await InterfaceNyeri.editNyeri(
      id,
      reg,
      unit_id,
      rm,
      param
    ).then((response) => {
      dt = response.data
    })
      .catch((e) => {
        dt = e.response
        ErrorAlert.showErrorAlert(e)
      });
    return dt
  }
}

export default new DataNyeri();